import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideRebuildRoute = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRebuildRouteRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideRebuildRoute,
    entity,
  );

  const bulkRebuildRouteRidesProcess = useRecoilValue(
    activeProcessSF(bulkRebuildRouteRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideRebuildRoute,
      toastSummaryOnComplete: true,
      process: bulkRebuildRouteRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkRebuildRouteRidesProcess, entity, onComplete, stopProcessPolling, t]);
};
